module.exports = __webpack_public_path__ + "static/img/72010A_7_R_20200801_fit.cb33989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/72010A_7_R_20200801_fit.png
// module id = 5TqO
// module chunks = 0